import { OrderViewerError } from './typing/enums';
import { IOrderViewerMainStore } from './typing/stores';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors, Icons } from 'copyright-clearance-center-common-ui';
import { inject, observer } from 'mobx-react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			gap: '0.25rem',
			flexDirection: 'row',
			alignSelf: 'stretch',
			alignItems: 'center'
		},
		infoBlock: {
			display: 'flex',
			flexDirection: 'column'
		},
		title: {
			color: Colors.error500
		},
		message: {
			color: Colors.error400
		}
	})
);

export interface IOrderViewerErrorProps {
	error?: OrderViewerError;
}

const errorMessages: Partial<{ [key in OrderViewerError]: { title: string; message: string } }> = {
	[OrderViewerError.NotFound]: {
		title: localize('Your request could not be processed'),
		message: localize('The specified order could not be located.')
	}
};

const OrderViewerErrorPage: React.FunctionComponent<IOrderViewerErrorProps> = props => {
	const classes = useStyles();
	const error = errorMessages[props.error];

	return (
		<div className={classes.root}>
			<div className={clsx(classes.title, 'rup-icon')}>
				<span dangerouslySetInnerHTML={{ __html: Icons.ErrorIcon }} />
			</div>
			<div className={classes.infoBlock}>
				<div className={clsx(classes.title, 'rup-heading-5')}>{error.title}</div>
				<div className={clsx(classes.message, 'rup-body')}>{error.message}</div>
			</div>
		</div>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	error: stores.orderViewerStore.viewModel.error
}))(observer(OrderViewerErrorPage));
